import { Injectable } from '@angular/core';
import { customConfig } from "../../../custom/custom-config";
import { CoreCOMService } from '../com.service';
import { LocalKeys, StorageHive } from '../valueStorage.service';
import { TrackingEvent } from './tracking-event.enum';
import { CoreLogService } from '../log.service';
import { TrackingPayload } from './payloads/tracking-payload.interface';
import { Tracker } from './tracker.interface';

@Injectable({
  providedIn: 'root'
})
export class MetaPixelService implements Tracker {
  private isInitialized: boolean;

  constructor(
    private _coreCOMService: CoreCOMService,
    private _coreLogService: CoreLogService,
  ) { }
  //basecode of meta pixel
  public load(): void {
    if (this.isInitialized) return;

    this._coreCOMService.environment.valueStorage.get(StorageHive.Local, LocalKeys.cookieConsentMeta).then((cookieConsentMeta) => {
      if (cookieConsentMeta) {
        (function (f: any, b, e, v, n, t, s) {
          if (f.fbq) return; n = f.fbq = function () {
            n.callMethod ?
              n.callMethod.apply(n, arguments) : n.queue.push(arguments)
          }; if (!f._fbq) f._fbq = n;
          n.push = n; n.loaded = !0; n.version = '2.0'; n.queue = []; t = b.createElement(e); t.async = !0;
          t.src = v; s = b.getElementsByTagName(e)[0]; s.parentNode.insertBefore(t, s)
        })(window, document, 'script', 'https://connect.facebook.net/en_US/fbevents.js');
        //customers meta-pixel id
        (window as any).fbq('init', customConfig.meta_pixel);
        this.isInitialized = true;

        /**
         * standard events of meta pixel
         * can be added, more infos:
         * https://developers.facebook.com/docs/meta-pixel/reference#standard-events
         */
      }
    });
  }

  //remove meta pixel with setting the cookie to expired
  public remove(): void {
    const cookies = document.cookie.split(';');
    for (const cookie of cookies) {
      const eqPos = cookie.indexOf("=");
      const name = eqPos > -1 ? cookie.substr(0, eqPos) : cookie;
      document.cookie = name + "=;domain=.myhypersoftapp.de;path=/;expires=" + new Date(0).toUTCString();
      delete (window as any).fbq;
      this.isInitialized = false;
    }
  }


  public isActive(): boolean {
    return typeof window !== 'undefined' && this.isInitialized;
  }

  fireEvent(event: TrackingEvent, payload: TrackingPayload): void {
    try {
      if (!payload) {
        (window as any).fbq("track", event);
        return;
      }

      const formattedData = (payload as any).toMetaFormat();
      (window as any).fbq("track", event, formattedData);
    } catch (e) {
      this._coreLogService.error(`MetaPixel: Error in event "${event}":`, e);
    }
  }
}
